export default __webpack_public_path__ + "static/media/fundo2.bcb1aadd.jpg";